import { Input, Component } from "@angular/core";
import { AbstractFlatWidget } from "src/app/shared/components/flat/abstract-flat-widget";
import { Cumulated } from "src/app/shared/jsonrpc/response/queryHistoricTimeseriesEnergyResponse";
import { EdgeConfig, Utils } from "src/app/shared/shared";
import { DefaultTypes } from "src/app/shared/type/defaulttypes";

@Component({
    selector: "DayProduction",
    templateUrl: "./dayproduction.html",
    standalone: false,
})
export class DayProductionComponent extends AbstractFlatWidget {
    @Input() public period: DefaultTypes.HistoryPeriod;

    public data: Cumulated = null;
    public chargerComponents: EdgeConfig.Component[] = [];
    public productionMeterComponents: EdgeConfig.Component[] = [];
    public readonly CONVERT_TO_KILO_WATTHOURS = Utils.CONVERT_TO_KILO_WATTHOURS;
    public readonly CONVERT_WATT_TO_KILOWATT = Utils.CONVERT_WATT_TO_KILOWATT;

    protected override getChannelAddresses() {
    // Get Chargers
        this.chargerComponents = this.config
            .getComponentsImplementingNature(
                "io.openems.edge.ess.dccharger.api.EssDcCharger",
            )
            .filter((component) => component.isEnabled);

        // Get productionMeters
        this.productionMeterComponents = this.config
            .getComponentsImplementingNature(
                "io.openems.edge.meter.api.ElectricityMeter",
            )
            .filter(
                (component) => component.isEnabled && this.config.isProducer(component),
            );

        return [];
    }
}
